import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const ScalarArgControl = (t0) => {
  const $ = c(8);
  const {
    name,
    inputType,
    step,
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = (e) => onChange(e.target.value);
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== inputType || $[3] !== name || $[4] !== step || $[5] !== t1 || $[6] !== value) {
    t2 = /* @__PURE__ */ jsx("input", { type: inputType, step, "aria-label": name, value, onChange: t1, className: "graphiql-qb-arg-input" });
    $[2] = inputType;
    $[3] = name;
    $[4] = step;
    $[5] = t1;
    $[6] = value;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
const BooleanArgControl = (t0) => {
  const $ = c(6);
  const {
    name,
    value,
    onChange
  } = t0;
  const t1 = value === "true";
  let t2;
  if ($[0] !== onChange) {
    t2 = (e) => onChange(e.target.checked ? "true" : "false");
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== name || $[3] !== t1 || $[4] !== t2) {
    t3 = /* @__PURE__ */ jsx("input", { type: "checkbox", "aria-label": name, checked: t1, onChange: t2, className: "graphiql-qb-arg-checkbox" });
    $[2] = name;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export {
  BooleanArgControl,
  ScalarArgControl
};
//# sourceMappingURL=scalar-arg-control.js.map
